import createIcon from '../../createIcon';

/**
 * @component @name DoubleArrow
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTUuMjUgNUgxMC43NUwxNS43NSAxMkwxMC43NSAxOUgxNS4yNUwyMC4yNSAxMkwxNS4yNSA1WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTguMjUgNUgzLjc1TDguNzUgMTJMMy43NSAxOUg4LjI1TDEzLjI1IDEyTDguMjUgNVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const DoubleArrow = createIcon('DoubleArrow', [
  ['path', { d: 'M15.25 5H10.75L15.75 12L10.75 19H15.25L20.25 12L15.25 5Z', key: 'kcz7o5' }],
  ['path', { d: 'M8.25 5H3.75L8.75 12L3.75 19H8.25L13.25 12L8.25 5Z', key: 'f0667p' }],
]);

export default DoubleArrow;
